import React from "react";

// core components

// ReactStrap
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    FormGroup,
    Form,
    Row,
    Col,
} from "reactstrap";

export default function AdminContactUs({ id, repName, email, phone, location, opening, setContactId, setSmallAlert, select, isDisplayed }) {

    return (
        <Col md="6">
            <Card className="card-contact card-raised">
                <CardHeader className="header-raised header-primary text-center">
                    <CardTitle tag="h4">Contact Us</CardTitle>
                </CardHeader>
                <Form id="contact-form2" method="post" role="form">
                    <CardBody>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <label className="control-label">Representative Name</label>
                                    <p>{repName}</p>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <label className="control-label">Email address</label>
                                    <p>{email}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <label className="control-label">Phone Number</label>
                                    <p>{phone}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <label className="control-label">Location</label>
                                    <p>{location}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <label className="control-label">Opening Times</label>
                                    <p>{opening}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <label className="control-label">Displayed Contact?</label>
                                    <p>{isDisplayed.toString().toUpperCase()}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="media-footer">
                            <Row>
                                <Col lg="8" xs="8" md="8">
                                    <Button
                                        className="btn-round mr-1"
                                        color="success"
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            select(id)
                                        }}
                                        style={{ minWidth: "100%" }}
                                    >
                                        Edit
                                            </Button>
                                </Col>
                                <Col lg="4" xs="4" md="4">
                                    <Button
                                        className="btn-round mr-1"
                                        color="danger"
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            setContactId(id)
                                            setSmallAlert(true)
                                        }}
                                        style={{ minWidth: "100%" }}
                                    >
                                        Delete
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </CardBody>
                </Form>
            </Card>
        </Col>
    );
}
